/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React from 'react';
import { Redirect } from 'react-router-dom';
import routeConfiguration from '../../routeConfiguration';
import { pathByRouteName } from '../../util/routes';

const NamedRedirect = props => {
  const { name, search = '', state = {}, push = false, params = {}  } = props;
  const pathname = pathByRouteName(name, routeConfiguration(), params);
  return <Redirect to={{ pathname, search, state }} push={push} />;
};

export default NamedRedirect;
